// extracted by mini-css-extract-plugin
module.exports = {"title":"Title_title__32T_p","text":"Title_text__3KSpX"};